import Vue from 'vue'
import Vuex from 'vuex'
import SecureLS from 'secure-ls'
import createPersistedState from 'vuex-persistedstate';
import system_data from './module/system'
import form_rules from './module/form_rules'
import authentication from './module/authentication'
import users from './module/user'
import transaction_months from './module/data/transaction_months'
import bank_depository from './module/data/bank_depository'
import deposit_slip from './module/data/deposit_slip'
import branch_information from './module/data/branch_information'
import table from './module/data/travel_order'
import menu_order from './module/data/service'
import table_order from './module/data/trave_order_services'
import purchase_order_slip from './module/data/purchase_order_slip'
import transaction_months_history from './module/data/transaction_months_history'
import customer from './module/data/customer'
import business_brenches from './module/data/business_brenches'
import business_owners from './module/data/business_owners'
import loan from './module/data/loan'
import loan_payments from './module/data/loan_payments'
import loan_deductions_payments from './module/data/loan_deductions_payments'


const ls = new SecureLS({
  isCompression: false,
})
Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState(
    {
      key: 'A-C-A',
      paths: ['authentication'],
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },
    },
  )],
  state: {},
  mutations: {},
  actions: {},
  modules: {
    system_data,
    form_rules,
    authentication,
    users,
    transaction_months,
    bank_depository,
    deposit_slip,
    branch_information,
    table,
    menu_order,
    table_order,
    purchase_order_slip,
    transaction_months_history,
    customer,
    business_brenches,
    business_owners,
    loan,
    loan_payments,
    loan_deductions_payments,
  },
})
